import React, { useState } from "react";
import { generateEditorContentStyle } from "./generate-editor-content-style";
import { Editor as TinyMCEEditor } from "@tinymce/tinymce-react";
import { Editor } from "tinymce";
import { Skeleton, useTheme } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

export type TextEditorProps = {
  // css string style
  editorContentStyle?: string;
  htmlContent: string;
  editorRef: React.MutableRefObject<Editor | null>;
  height?: number;
  selectAllOnLoad?: boolean;
};

const EditorWrapper = styled.div`
  min-height: 400px;
  height: 100%;
  width: 100%;

  ${({ theme }) => generateEditorContentStyle(theme)}
`;

export const TextEditor = (props: TextEditorProps) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const {
    editorContentStyle = generateEditorContentStyle(theme),
    htmlContent,
    editorRef,
    height = 400,
    selectAllOnLoad = false,
  } = props;
  return (
    <EditorWrapper>
      {isLoading ? <Skeleton height={height} variant="rounded" /> : null}
      <div hidden={isLoading}>
        <TinyMCEEditor
          onInit={(evt, editor) => {
            editorRef.current = editor;
            if (selectAllOnLoad) {
              setTimeout(() => {
                editor.selection.select(editor.getBody(), true);
              }, 100);
            }
          }}
          initialValue={htmlContent}
          onLoadContent={() => setIsLoading(false)}
          init={{
            body_class: "text-editor-body",
            height,
            max_height: 627,
            auto_focus: true,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "preview",
              "anchor",
              "wordcount",
            ],
            toolbar: `undo redo | casechange blocks fontsize | bold italic link | alignleft aligncenter alignright alignjustify | bullist numlist`,
            content_style: editorContentStyle,
            link_default_target: "_blank",
            block_formats: "Paragraph=p; Heading 1=h4; Heading 2=h5;",
            font_size_formats: "8px 10px 12px 14px 18px 24px 32px 36px",
          }}
          apiKey={process.env.TINYMCE_API_KEY}
        />
      </div>
    </EditorWrapper>
  );
};
